import { Guid, Nillable } from '@web/utils';
import {
  SubscriptionNumber,
  SubscriptionStatus,
} from '@web/shared/module/shop';
import { AdminSubscriptionSubscriber } from './admin-subscription-subscriber';

export class AdminSubscriptionCollectionItem {
  public constructor(
    private readonly data: {
      canBillingAddressBeUpdated: boolean;
      canShippingAddressBeUpdated: boolean;
      canBeViewed: boolean;
      canBeCancelled: boolean;
      canBeProcessed: boolean;
      canBeUpdated: boolean;
      canBeSuspended: boolean;
      canBeResumed: boolean;
      id: Guid;
      isLocked: boolean;
      number: SubscriptionNumber;
      status: SubscriptionStatus;
      totalPrice: number;
      nextPaymentDate?: Nillable<Date>;
      secondPaymentDate?: Nillable<Date>;
      thirdPaymentDate?: Nillable<Date>;
      lastPaymentDate: Date;
      createdAt: Date;
      cardExpiryDate?: Nillable<string>;
      cardNumber?: Nillable<string>;
      subscriber: AdminSubscriptionSubscriber;
    },
  ) {}

  public get canBillingAddressBeUpdated(): boolean {
    return this.data.canBillingAddressBeUpdated;
  }

  public get canShippingAddressBeUpdated(): boolean {
    return this.data.canShippingAddressBeUpdated;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeCancelled(): boolean {
    return this.data.canBeCancelled;
  }

  public get canBeProcessed(): boolean {
    return this.data.canBeProcessed;
  }

  public get canBeUpdated(): boolean {
    return this.data.canBeUpdated;
  }

  public get canBeSuspended(): boolean {
    return this.data.canBeSuspended;
  }

  public get canBeResumed(): boolean {
    return this.data.canBeResumed;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get isLocked(): boolean {
    return this.data.isLocked;
  }

  public get number(): SubscriptionNumber {
    return this.data.number;
  }

  public get status(): SubscriptionStatus {
    return this.data.status;
  }

  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get nextPaymentDate(): Nillable<Date> {
    return this.data.nextPaymentDate;
  }

  public get secondPaymentDate(): Nillable<Date> {
    return this.data.secondPaymentDate;
  }

  public get thirdPaymentDate(): Nillable<Date> {
    return this.data.thirdPaymentDate;
  }

  public get lastPaymentDate(): Date {
    return this.data.lastPaymentDate;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get cardExpiryDate(): Nillable<string> {
    return this.data.cardExpiryDate;
  }

  public get cardNumber(): Nillable<string> {
    return this.data.cardNumber;
  }

  public get subscriber(): AdminSubscriptionSubscriber {
    return this.data.subscriber;
  }
}
